const MULTI_PRODUCT_SELECTOR_ADDON_VARIANT_MAP = {
    necklace: [
        {
            mainVariantIds: [58313387540805, 58313390293317, 58313390358853],
            addonVariantId: 58178955706693,
        },
        {
            mainVariantIds: [58313387573573, 58313390326085, 58313390391621],
            addonVariantId: 58178955739461,
        },
    ],
    bracelet: [
        {
            mainVariantIds: [58313387573573, 58313390326085, 58313390391621],
            addonVariantId: 58180006052165,
        },
        {
            mainVariantIds: [58313387540805, 58313390293317, 58313390358853],
            addonVariantId: 58180006019397,
        },
    ],
};

if (!customElements.get("multi-product-selector")) {
    customElements.define(
        "multi-product-selector",
        class MultiProductSelector extends HTMLElement {
            connectedCallback() {
                this.sectionId = this.dataset.sectionId;
                this.productId = this.dataset.productId;
                this.requiredError =
                    this.dataset.requiredError ||
                    "Please complete your selections.";
                this.form = this.sectionId
                    ? document.getElementById(`product-form-${this.sectionId}`)
                    : null;
                this.submitButton = this.sectionId
                    ? document.getElementById(
                          `ProductSubmitButton-${this.sectionId}`,
                      )
                    : null;
                this.variantInput = this.form?.querySelector('[name="id"]');
                this.message = this.querySelector("[data-message]");
                this.total = this.querySelector("[data-bundle-total]");
                this.totalOriginal = this.total?.querySelector(
                    "[data-bundle-total-original]",
                );
                this.totalDiscounted = this.total?.querySelector(
                    "[data-bundle-total-discounted]",
                );
                this.totalSaved = this.total?.querySelector(
                    "[data-bundle-total-saved]",
                );
                this.totalSavedText =
                    this.dataset.totalSavedText || "Save [amount]";
                this.optionInputs = Array.from(
                    this.querySelectorAll("[data-option-input]"),
                );
                this.addonInputs = Array.from(
                    this.querySelectorAll("[data-addon-input]"),
                );
                this.mainProduct = this.parseJson(
                    this.querySelector("[data-main-product-json]"),
                );
                this.addonProducts = Array.from(
                    this.querySelectorAll("[data-addon-product-json]"),
                )
                    .map((script) => {
                        const product = this.parseJson(script);
                        const input = script
                            .closest(".multi-product-selector__tile")
                            ?.querySelector("[data-addon-input]");
                        return { product, input };
                    })
                    .filter((entry) => entry.product && entry.input);

                this.optionInputs.forEach((input) =>
                    input.addEventListener("change", () => this.update()),
                );
                this.addonInputs.forEach((input) =>
                    input.addEventListener("change", () => this.updateAddons()),
                );
                if (this.form)
                    this.form.addEventListener(
                        "submit",
                        (event) => this.handleSubmit(event),
                        true,
                    );
                this.form
                    ?.querySelector('[name="quantity"]')
                    ?.addEventListener("change", () => this.updateTotal());
                this.form
                    ?.querySelector('[name="quantity"]')
                    ?.addEventListener("input", () => this.updateTotal());

                this.update();
            }

            parseJson(script) {
                if (!script?.textContent) return null;

                try {
                    return JSON.parse(script.textContent);
                } catch (error) {
                    return null;
                }
            }

            selectedOptions() {
                return (this.mainProduct?.options || []).map(
                    (option, index) => {
                        const input = this.querySelector(
                            `[data-option-input][data-option-index="${index}"]:checked`,
                        );
                        return {
                            index,
                            name: option.name,
                            value: input?.value || option.values?.[0],
                        };
                    },
                );
            }

            selectedOptionValues() {
                return this.selectedOptions().map((option) => option.value);
            }

            selectedMainVariant() {
                const values = this.selectedOptionValues();
                const variants = this.mainProduct?.variants || [];

                return (
                    variants.find(
                        (variant) =>
                            this.variantMatchesValues(variant, values) &&
                            variant.available,
                    ) ||
                    variants.find((variant) =>
                        this.variantMatchesValues(variant, values),
                    ) ||
                    null
                );
            }

            variantMatchesValues(variant, values) {
                return values.every(
                    (value, index) => variant.options?.[index] === value,
                );
            }

            update() {
                const variant = this.selectedMainVariant();
                this.syncVariantInput(variant);
                this.updateMedia(variant);
                this.updateButton(variant);
                this.updateFinishAddonText();
                this.updateAddons();
                this.updateTotal(variant);
                this.hideMessage();
            }

            syncVariantInput(variant) {
                if (!this.variantInput || !variant?.id) return;

                this.variantInput.value = variant.id;
                this.variantInput.disabled = !variant.available;
                this.variantInput.dispatchEvent(
                    new Event("change", { bubbles: true }),
                );
            }

            updateButton(variant) {
                if (!this.submitButton) return;

                if (!variant?.available) {
                    this.submitButton.disabled = true;
                    this.submitButton.setAttribute("aria-disabled", true);
                    return;
                }

                this.submitButton.disabled = false;
                this.submitButton.removeAttribute("aria-disabled");
            }

            updateMedia(variant) {
                if (this.dataset.updateMedia === "false") return;
                if (!this.sectionId || !variant?.featured_media_id) return;

                const sectionMediaId = `${this.sectionId}-${variant.featured_media_id}`;
                const mediaGalleries = document.querySelectorAll(
                    `[id^="MediaGallery-${this.sectionId}"]`,
                );

                mediaGalleries.forEach((mediaGallery) => {
                    if (typeof mediaGallery.setActiveMedia !== "function")
                        return;
                    if (
                        !mediaGallery.querySelector(
                            `[data-media-id="${sectionMediaId}"]`,
                        )
                    )
                        return;

                    mediaGallery.setActiveMedia(sectionMediaId, true);
                });

                const modalContent = document.querySelector(
                    `#ProductModal-${this.sectionId} .product-media-modal__content`,
                );
                const modalMedia = modalContent?.querySelector(
                    `[data-media-id="${variant.featured_media_id}"]`,
                );
                if (modalMedia) modalContent.prepend(modalMedia);
            }

            updateAddons() {
                this.addonProducts.forEach(({ product, input }) => {
                    const variant = this.matchAddonVariant(product);
                    input.dataset.variantId = variant?.id || "";
                    input.disabled = !variant?.available;
                    const price = input
                        .closest(".multi-product-selector__tile")
                        ?.querySelector("[data-addon-price]");
                    if (price && variant?.price != null)
                        price.textContent = this.formatMoney(variant.price);

                    if (!variant?.available) input.checked = false;
                });

                this.updateTotal(this.selectedMainVariant());
            }

            updateFinishAddonText() {
                const finishOption = this.selectedOptions().find((option) =>
                    this.normalize(option.name).includes("finish"),
                );
                if (!finishOption?.value) return;

                this.querySelectorAll(
                    ".multi-product-selector__tile-titles .multi-product-selector__tile-meta",
                ).forEach((meta) => {
                    meta.textContent = finishOption.value;
                });
            }

            selectedMediaPillItems() {
                const optionItems = this.selectedOptions()
                    .map((option) => option.value)
                    .filter(Boolean)
                    .map((value) => ({ type: "option", value }));
                const addonItems = this.addonInputs
                    .filter((input) => input.checked)
                    .map((input) => input.value)
                    .filter(Boolean)
                    .map((value) => ({ type: "addon", value }));

                return [...optionItems, ...addonItems];
            }

            mediaGalleryElements() {
                if (!this.sectionId) return [];

                const section = document.getElementById(
                    `MainProduct-${this.sectionId}`,
                );

                return Array.from(
                    section?.querySelectorAll(
                        ".product__media-wrapper media-gallery",
                    ) || [],
                );
            }

            selectedMediaSummary(mediaGallery) {
                const wrapper = mediaGallery.closest(".product__media-wrapper");
                let summary = Array.from(wrapper?.children || []).find(
                    (element) =>
                        element.dataset.multiProductSelectedSummary === this.id,
                );

                if (summary) return summary;

                summary = document.createElement("div");
                summary.className = "multi-product-selector-media-summary";
                summary.dataset.multiProductSelectedSummary = this.id;
                mediaGallery.insertAdjacentElement("afterend", summary);

                return summary;
            }

            updateTotal(variant = this.selectedMainVariant()) {
                if (!this.total || !this.totalDiscounted) return;

                const mainTotal =
                    Number(variant?.price || 0) * this.formQuantity();
                const selectedAddons = this.addonInputs.filter(
                    (input) => input.checked,
                );
                const addonOriginalTotal = selectedAddons.reduce(
                    (total, input) =>
                        total + Number(input.dataset.addonPriceCents || 0),
                    0,
                );
                const addonDiscount = selectedAddons.reduce(
                    (total, input) =>
                        total + Number(input.dataset.addonDiscountCents || 0),
                    0,
                );
                const addonDiscountedTotal = selectedAddons.reduce(
                    (total, input) =>
                        total + Number(input.dataset.addonFinalPriceCents || 0),
                    0,
                );
                const original = mainTotal + addonOriginalTotal;
                const discounted = mainTotal + addonDiscountedTotal;
                const discount = Math.min(addonDiscount, original);

                if (this.totalOriginal) {
                    this.totalOriginal.textContent =
                        discount > 0 ? this.formatMoney(original) : "";
                    this.totalOriginal.hidden = discount <= 0;
                }

                this.totalDiscounted.textContent = this.formatMoney(discounted);

                if (this.totalSaved) {
                    this.totalSaved.textContent =
                        discount > 0
                            ? this.totalSavedText.replace(
                                  "[amount]",
                                  this.formatMoney(discount),
                              )
                            : "";
                    this.totalSaved.hidden = discount <= 0;
                }
            }

            matchAddonVariant(product) {
                const selectedOptions = this.selectedOptions();
                const selectedByName = new Map(
                    selectedOptions.map((option) => [
                        this.normalize(option.name),
                        option.value,
                    ]),
                );
                const addonOptionNames = (product.options || []).map((option) =>
                    this.normalize(option.name),
                );

                const variants = product.variants || [];
                const exactByName =
                    variants.find(
                        (variant) =>
                            this.addonVariantMatchesByName(
                                variant,
                                addonOptionNames,
                                selectedByName,
                            ) && variant.available,
                    ) ||
                    variants.find((variant) =>
                        this.addonVariantMatchesByName(
                            variant,
                            addonOptionNames,
                            selectedByName,
                        ),
                    );
                if (exactByName) return exactByName;

                const selectedValues = selectedOptions.map(
                    (option) => option.value,
                );
                return (
                    variants.find(
                        (variant) =>
                            this.addonVariantMatchesByPosition(
                                variant,
                                selectedValues,
                            ) && variant.available,
                    ) ||
                    variants.find((variant) =>
                        this.addonVariantMatchesByPosition(
                            variant,
                            selectedValues,
                        ),
                    ) ||
                    variants.find((variant) => variant.available) ||
                    variants[0] ||
                    null
                );
            }

            addonVariantMatchesByName(
                variant,
                addonOptionNames,
                selectedByName,
            ) {
                let compared = 0;

                return (
                    addonOptionNames.every((name, index) => {
                        if (!selectedByName.has(name)) return true;

                        compared += 1;
                        return (
                            variant.options?.[index] ===
                            selectedByName.get(name)
                        );
                    }) && compared > 0
                );
            }

            addonVariantMatchesByPosition(variant, selectedValues) {
                return (variant.options || []).every((value, index) => {
                    return (
                        selectedValues[index] == null ||
                        value === selectedValues[index]
                    );
                });
            }

            selectedAddonLineItems(mainVariant = this.selectedMainVariant()) {
                return this.addonInputs
                    .filter((input) => input.checked)
                    .map((input) => {
                        const mappedVariantId = this.mappedAddonVariantId(
                            input,
                            mainVariant,
                        );
                        const variantId =
                            mappedVariantId || Number(input.dataset.variantId);

                        if (!variantId) return null;

                        return {
                            id: variantId,
                            quantity: 1,
                        };
                    })
                    .filter(Boolean);
            }

            mappedAddonVariantId(input, mainVariant) {
                const rules =
                    MULTI_PRODUCT_SELECTOR_ADDON_VARIANT_MAP[
                        this.normalize(input.value)
                    ] || [];
                const mainVariantId = Number(mainVariant?.id);
                const rule = rules.find((entry) =>
                    entry.mainVariantIds.includes(mainVariantId),
                );

                return rule ? Number(rule.addonVariantId) : null;
            }

            handleSubmit(event) {
                const variant = this.selectedMainVariant();
                this.syncVariantInput(variant);

                if (!variant?.available) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    this.showMessage(this.requiredError);
                    return;
                }

                const addonItems = this.selectedAddonLineItems(variant);
                if (!addonItems.length) return;

                event.preventDefault();
                event.stopImmediatePropagation();
                this.checkout([this.mainLineItem(variant), ...addonItems]);
            }

            mainLineItem(variant) {
                const item = {
                    id: Number(variant.id),
                    quantity: this.formQuantity(),
                };
                const formData = this.form ? new FormData(this.form) : null;
                const sellingPlan = formData?.get("selling_plan");
                const properties = {};

                if (sellingPlan) item.selling_plan = Number(sellingPlan);

                formData?.forEach((value, key) => {
                    const match = key.match(/^properties\[(.+)]$/);
                    if (!match || value === "") return;

                    properties[match[1]] = value;
                });

                if (Object.keys(properties).length)
                    item.properties = properties;

                return item;
            }

            formQuantity() {
                const quantity = Number(
                    this.form?.querySelector('[name="quantity"]')?.value || 1,
                );
                return Math.max(quantity || 1, 1);
            }

            async checkout(items) {
                if (this.submitButton) {
                    this.submitButton.disabled = true;
                    this.submitButton.setAttribute("aria-disabled", true);
                }

                try {
                    const response = await fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        },
                        body: JSON.stringify(this.cartRequestBody(items)),
                    });

                    const data = await response.json();

                    if (!response.ok || data.status) {
                        throw new Error(
                            data.description ||
                                data.message ||
                                "Unable to add these items to cart.",
                        );
                    }

                    await this.openCart(data);
                } catch (error) {
                    this.showMessage(error.message);
                } finally {
                    const variant = this.selectedMainVariant();
                    this.updateButton(variant);
                }
            }

            cartRequestBody(items) {
                const cartDrawer = document.querySelector("cart-drawer");
                const body = { items };

                if (
                    cartDrawer &&
                    typeof cartDrawer.getSectionsToRender === "function"
                ) {
                    body.sections = cartDrawer
                        .getSectionsToRender()
                        .map((section) => section.id);
                    body.sections_url = window.location.pathname;
                    if (typeof cartDrawer.setActiveElement === "function")
                        cartDrawer.setActiveElement(document.activeElement);
                }

                return body;
            }

            async openCart(parsedState) {
                const cartDrawer = document.querySelector("cart-drawer");

                if (
                    cartDrawer &&
                    typeof cartDrawer.renderContents === "function"
                ) {
                    const cartState = parsedState.sections
                        ? parsedState
                        : await this.getUpdatedCartState(cartDrawer);
                    cartDrawer.renderContents(cartState);
                    return;
                }

                window.location.href = window.routes?.cart_url || "/cart";
            }

            async getUpdatedCartState(cartDrawer) {
                const sectionIds = cartDrawer
                    .getSectionsToRender()
                    .map((section) => section.id);
                const url = new URL(
                    window.location.pathname,
                    window.location.origin,
                );
                url.searchParams.set("sections", sectionIds.join(","));
                url.searchParams.set("sections_url", window.location.pathname);

                const response = await fetch(url.toString());
                if (!response.ok) throw new Error("Unable to refresh cart.");

                return {
                    sections: await response.json(),
                };
            }

            formatMoney(cents) {
                return new Intl.NumberFormat(this.dataset.locale || "en-US", {
                    style: "currency",
                    currency: this.dataset.currencyCode || "USD",
                }).format((Number(cents) || 0) / 100);
            }

            normalize(value) {
                return String(value || "")
                    .trim()
                    .toLowerCase();
            }

            showMessage(text) {
                if (!this.message) return;
                this.message.textContent = text;
                this.message.hidden = false;
            }

            hideMessage() {
                if (!this.message) return;
                this.message.textContent = "";
                this.message.hidden = true;
            }
        },
    );
}
